export enum TimelineTempo {
    SLOW = 1,
    MEDIUM = 2,
    FAST = 3,
}

export const TimelineTempos = [
    { id: TimelineTempo.SLOW, name: 'Slow' },
    { id: TimelineTempo.MEDIUM, name: 'Medium' },
    { id: TimelineTempo.FAST, name: 'Fast' },
];
